import { createSelector } from '@reduxjs/toolkit'
import { QuoteReservation } from '@/models/quote.ts'
import { cartSlice } from '..'

type FormattedReservations = Record<string, QuoteReservation>

export const formattedReservationsSelector = createSelector(
  [cartSlice.selectors.cartReservations],
  (cartReservations): FormattedReservations => {
    return cartReservations.reduce<FormattedReservations>(
      (acc, reservation) => {
        return {
          ...acc,
          [`_${reservation.spotType}_${reservation.spotName}`]: reservation,
        }
      },
      {}
    )
  }
)
